import React, { useState, useRef, useEffect } from 'react'
import { Carousel, Card, Button } from 'antd'

export default function InfoContent({ contents = [], autoplay = true, mainAction, onFinish }) {
    const [current, setCurrent] = useState(contents.length - 1)
    const c_ref = useRef()

    function onChange(currentSlide) {
        setCurrent(currentSlide)
    }

    function next() {
        if (current > 0) {
            setCurrent(current - 1)
        } else if (onFinish) {
            onFinish()
        }
    }

    useEffect(() => {
        if (c_ref.current) {
            c_ref.current.goTo(current)
        }
    }, [current])

    const finished = current == 0
    return <div style={{ padding: '72px 72px 0' }} className='no-header-sibling'>
        <div>
            <Carousel
                autoplay={autoplay}
                afterChange={onChange}
                dotPosition="bottom"
                rtl
                infinite={false}
                ref={c_ref}
            >
                {contents.map((content, index) => (
                    <Card
                        key={index}
                        bodyStyle={{ direction: "rtl" }}
                        bordered={false}
                        cover={
                            <img
                                alt="image"
                                src={content.img}
                            />
                        }>
                        <Card.Meta
                            title={content.title}
                            description={content.description}
                        />

                    </Card>
                )
                )}
            </Carousel>

            {!autoplay && <Button className=' br-24 f-16 btn-40' type="primary" block onClick={next}>
                بعدی
            </Button>}
        </div>
        {finished && mainAction}
    </div>
}